import KSimpleSelect from 'app/components/Modules/Form/KSimpleSelect'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

export const PROJECT_TYPE_OPTIONS: Array<IProject_type> = [
  'photovoltaic_systems',
  'serial_refurbishment',
  'pipeline_and_network_construction',
  'railway_systems_and_track_construction',
  'bridge_and_tunnel_construction',
  'other'
]

const ProjectTypeSelect: React.FC = () => {
  const { tAttribute } = useTranslation({ recordType: RecordType.project })

  const options = PROJECT_TYPE_OPTIONS.map((type) => ({
    label: tAttribute({ id: `project_type_options.${type}` }),
    value: type
  }))

  return <KSimpleSelect options={options} name={'project_type'} />
}

export default ProjectTypeSelect
